import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["eclipseInput"], {
    modelValue: $setup.proxyModelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.proxyModelValue) = $event)),
    "input-state": $setup.props.inputState,
    "form-input-meta": $setup.props.formInputMeta,
    "dropdown-option-keys": $setup.mainSolutionInterestOpts,
    "dropdown-translations-namespace": "main-solutions"
  }, null, 8 /* PROPS */, ["modelValue", "input-state", "form-input-meta", "dropdown-option-keys"]))
}